import { toPlaybackRateOption, toQualityOption } from './utils'

export const OPTIONS = {
  PLAYBACK_RATE: [0.75, 1, 1.25, 1.5, 2],
  QUALITIES: [720, 480, 360],
} as const

export const PLAYBACK_RATE_OPTION = OPTIONS.PLAYBACK_RATE.map(
  toPlaybackRateOption
)
export const QUALITY_OPTION = OPTIONS.QUALITIES.map(toQualityOption)

export type PLAYBACK_RATE = typeof OPTIONS.PLAYBACK_RATE[number]
export type QUALITIES = typeof OPTIONS.QUALITIES[number]
export const INITIAL_SAVED_CURRENT_TIME = 0
